module.exports = __webpack_public_path__ + "img/slack.78155898.png";